import {Avatar, Icon, Layout, Menu, Popup} from '@di-nxt/components';
import React, {useCallback} from 'react';
import {Team, TeamsLoader, useTeams} from '../../services';

type Props = {
  selectedTeamId?: number;
  onChangeTeam: (team: Team) => void;
};

export const TeamsSelector: React.FC<Props> = ({
  selectedTeamId,
  onChangeTeam,
}) => {
  // Data
  const teams = useTeams();

  // Callbacks
  const handleSelectTeam = useCallback(
    (index: number) => {
      onChangeTeam(teams[index]);
    },
    [onChangeTeam, teams],
  );

  return (
    <Layout vertical flex>
      <TeamsLoader />
      {/* Teams display */}
      <Popup
        trigger={
          <Layout align="center" backgroundColor="background_mono_primary">
            <Avatar
              shape="square"
              name={teams.find(t => t.id === selectedTeamId)?.name ?? ''}
              uri={undefined}
            />
            <Icon name="arrowDownSmall" />
          </Layout>
        }>
        {(closePopup) => <Menu
          items={teams.map(t => t.name)}
          selectedIndex={teams.findIndex(t => t.id === selectedTeamId)}
          onChange={index => {
            handleSelectTeam(index);
            closePopup();
          }}
        />}
      </Popup>
    </Layout>
  );
};
